export const treasureOriginal = (ctx: CanvasRenderingContext2D, thumbOverColor: string, thumbToWristColor: string, stitchColor: string): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = thumbOverColor
  ctx.beginPath()
  ctx.moveTo(454, 472) // 左上
  ctx.quadraticCurveTo(439, 479, 436, 490) //
  ctx.quadraticCurveTo(449, 499, 449, 499) //
  ctx.quadraticCurveTo(474, 470, 504, 457) //
  ctx.quadraticCurveTo(420, 525, 450, 592) // 左下
  ctx.quadraticCurveTo(481, 591, 529, 585) // 右下
  ctx.quadraticCurveTo(570, 556, 587, 496) // 右下＿右上1
  ctx.quadraticCurveTo(586, 480, 586, 480) // 右下＿右上2
  ctx.quadraticCurveTo(551, 548, 527, 568) // 右下の左上
  ctx.quadraticCurveTo(539, 497, 567, 428) //
  ctx.quadraticCurveTo(605, 406, 624, 364) //
  ctx.quadraticCurveTo(611, 358, 611, 358) //
  ctx.quadraticCurveTo(555, 413, 500, 435) //
  ctx.quadraticCurveTo(454, 472, 454, 472) //
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // 下地部分
  ctx.fillStyle = thumbToWristColor
  ctx.beginPath()
  ctx.moveTo(503, 477) // 左上
  ctx.quadraticCurveTo(469, 534, 473, 560) //
  ctx.quadraticCurveTo(494, 537, 503, 477) //
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  // 下地部分
  ctx.beginPath()
  ctx.moveTo(542, 444) //
  ctx.quadraticCurveTo(525, 454, 517, 470) //
  ctx.quadraticCurveTo(510, 555, 483, 569) //
  ctx.quadraticCurveTo(493, 577, 513, 566) //
  ctx.quadraticCurveTo(522, 498, 542, 444) //
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // ステッチここから
  ctx.lineWidth = 1.2
  ctx.strokeStyle = stitchColor
  ctx.beginPath()
  ctx.setLineDash([3, 3])
  ctx.moveTo(439, 488) //
  ctx.quadraticCurveTo(448, 495, 448, 495) //
  ctx.quadraticCurveTo(482, 458, 509, 455) //
  ctx.quadraticCurveTo(424, 527, 453, 589) //

  ctx.moveTo(499, 438) //
  ctx.quadraticCurveTo(576, 405, 611, 360) //
  ctx.quadraticCurveTo(620, 365, 620, 365) //
  ctx.quadraticCurveTo(607, 401, 565, 425) //
  ctx.quadraticCurveTo(534, 502, 524, 573) //
  ctx.quadraticCurveTo(562, 543, 585, 487) // 右上1
  ctx.quadraticCurveTo(584, 498, 584, 498) // 右上2
  ctx.quadraticCurveTo(561, 563, 529, 582) //
  //
  ctx.moveTo(505, 473) //
  ctx.quadraticCurveTo(466, 528, 471, 565) //
  ctx.quadraticCurveTo(504, 525, 505, 473) //
  //
  ctx.moveTo(480, 569) // 左下
  ctx.quadraticCurveTo(493, 582, 515, 568) //
  ctx.quadraticCurveTo(522, 514, 546, 439) //
  ctx.quadraticCurveTo(525, 449, 513, 471) //
  ctx.quadraticCurveTo(513, 538, 480, 569) //
  // ステッチここまで
  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
}

// interface F {
//   right: () => this
//   left: () => this
// }

// class OpenF implements F {
//   constructor() {}
//   right() {
//     return this
//   }
//   left() {
//     return this
//   }
// }
// class CloseF implements F {
//   constructor() {}
//   right() {
//     return this
//   }
//   left() {
//     return this
//   }
// }

// const mode = 'open'

// let f: F
// let m: F
// if (mode === 'open') {
//   f = new OpenF()
//   m = new OpenF()
// } else {
//   f = new CloseF()
//   m = new OpenF()
// }

// f.right().left()
// m.right().left()

// const models = ['UA', 'JA', 'US'] as const
// type Model = typeof models[number]
// const state: Model = 'UA'

// const fingerFactory = (model: Model) => {
//   let f: F
//   let f2: F
//   if (model === 'UA') {
//     f = new OpenF()
//     f2 = new OpenF()
//   }
//   if (model === 'JA') {
//     f = new OpenF()
//     f2 = new OpenF()
//   }
//   return { f, f2 }
// }

// const fingers = fingerFactory('UA')

// fingers.f.left().right()
// fingers.f2.left().right()
